import { Environment } from '../../shared/environment/environment';
var PincodeServiceFactory = /** @class */ (function () {
    function PincodeServiceFactory() {
    }
    // This factory exists to keep the 'function call' Environment.environmentConfig out of the app.module
    // Directly calling the environmentConfig in app.module will result in an error saying Function calls are not supported in Decorators
    PincodeServiceFactory.createPincodeService = function (localApiService) {
        var serviceType = Environment.environmentConfig().pincodeServiceType;
        return new serviceType(localApiService);
    };
    return PincodeServiceFactory;
}());
export { PincodeServiceFactory };
